import { ILoyaltyRedeemOffersRequest, ILoyaltyRedeemOffersAttr} from '~api/interfaces/ILoyaltyCartAPI';

export const RedeemOffers = (redeemOffersParam: ILoyaltyRedeemOffersRequest) => {

    const { redeemOffers } = redeemOffersParam;

    const redeemOffersQuery = `
        mutation  {
            redeemMultipleOffers (
                offers: [
                    ${
                        redeemOffers.map((redeemOffer: ILoyaltyRedeemOffersAttr, index) => (
                            `{
                                offerCode: "${redeemOffer.offerCode}",
                                ${
                                    ( redeemOffer.skuBaseId
                                    &&  (` skuBaseId: ["${redeemOffer.skuBaseId}"]`) || '' )
                                }
                            }`
                        )).join(',')
                    }
                ]
            )
            {
                id
                success
                errorDetail
                userOfferSuccessMessage
                userOfferErrorMessage
                userOfferCode
            }
        }
    `;

    return redeemOffersQuery;
};
